export function SkeletonCard() {
  return <div className="skeleton skeleton-card" aria-hidden="true" />;
}

export function SkeletonRow({ colSpan = 1 }: { colSpan?: number }) {
  return (
    <tr aria-hidden="true">
      <td colSpan={colSpan}>
        <div className="skeleton skeleton-row" />
      </td>
    </tr>
  );
}

export function SkeletonRows({ rows = 4, colSpan = 1 }: { rows?: number; colSpan?: number }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <SkeletonRow key={i} colSpan={colSpan} />
      ))}
    </>
  );
}

export function SkeletonStatRow({ count = 4 }: { count?: number }) {
  return (
    <div className="stats-grid">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}
